import { render } from "./HistoryOwnPage.vue?vue&type=template&id=756c53c3&scoped=true"
import script from "./HistoryOwnPage.vue?vue&type=script&lang=js"
export * from "./HistoryOwnPage.vue?vue&type=script&lang=js"

import "./HistoryOwnPage.vue?vue&type=style&index=0&id=756c53c3&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756c53c3"]])

export default __exports__